/**
 * Yellow pill rendered inline next to a gated action label.
 * Pairs with ProModal: the badge marks the action, the modal handles
 * the click-through "subscribe" flow.
 */
export function ProBadge() {
  return (
    <span className="inline-flex items-center px-1.5 py-0.5 ml-1.5 text-[10px] font-bold tracking-wide bg-yellow-400 text-yellow-950 rounded uppercase">
      PRO
    </span>
  );
}
